import { createContext, useContext } from "react";

/** Search sets this while a chosen place is on screen. Null means use the resident's own weather. */
export const RainOverrideContext = createContext<(code: number | null) => void>(() => {});

export function useRainOverride() {
  return useContext(RainOverrideContext);
}
